'use client'

import { SKUSelectionCta } from '@src/components/SKUSelectionCta/SKUSelectionCta'
import type { SKUSelectionFooterProps } from '@src/components/SKUSelectionFooter/SKUSelectionFooter.props'
import { StickyFooter } from '@src/components/StickyFooter/StickyFooter'
import { isSelectionStateValid, useSKUSelectionStore } from '@src/stores/SKUSelectionStore'
import { useBreakpoints } from '@src/utils/breakpoints.util'
import { cn } from '@src/utils/tailwind'

export const SKUSelectionFooter = (props: SKUSelectionFooterProps) => {
  const { buttonCopy, heading, invalidStateMessage, stickyFooterProps, redirectUrl, extraSkus } =
    props
  const groups = useSKUSelectionStore((state) => state.groups)
  const groupRestrictions = useSKUSelectionStore((state) => state.groupRestrictions)

  const isValid = isSelectionStateValid(groups, groupRestrictions)

  const { isDesktop } = useBreakpoints()

  return (
    <StickyFooter {...stickyFooterProps} className="h-[152px] py-0 lg:h-[100px] lg:py-0">
      <div className="flex flex-col items-center gap-4 lg:flex-row lg:justify-between">
        <div className="flex flex-col text-center lg:text-left">
          <h2 className="text-heading-display-3 text-white">{heading}</h2>
          {(!isDesktop || !isValid) && (
            <p
              className={cn('text-body-sm text-bodi-gray-butters', {
                'opacity-0': isValid,
              })}
              dangerouslySetInnerHTML={{ __html: invalidStateMessage ?? '' }}
            />
          )}
        </div>
        <SKUSelectionCta copy={buttonCopy} redirectUrl={redirectUrl} extraSkus={extraSkus} />
      </div>
    </StickyFooter>
  )
}
